import { call, put, takeLatest } from "redux-saga/effects";

import { authAPI } from "../api/auth.api";
import { AuthActionTypes } from "../actions/actionTypes";
import { Action } from "../../../actions/actions";
import { skeletonStore } from "../../../store";
import { SkeletonActionCreators } from "../../../actions/actionCreators";
import { ToasterService } from "../../../services/toaster/toaster.service";
import { responseCodePipe } from "../../../services/code_matcher/response_code_pipe.service";
import { loginSignupFailMessages } from "../assets/errorMessages.strings";
import { API } from "../../../api/api";

function* login(action: Action) {
    try {
        const token = yield call(authAPI.login, action.payload);

        yield put({
            type: AuthActionTypes.LOGIN_SUCCESS,
            payload: token
        });
    } catch (e) {
        yield put({
            type: AuthActionTypes.LOGIN_FAIL,
            error: e.response && e.response.data ? e.response.data.code : null
        });
    }
}

export function* loginWatcher() {
    yield takeLatest(AuthActionTypes.LOGIN, login);
}

function* loginSuccess(action: Action) {
    try {
        localStorage.setItem("sessionid", action.payload.data.token);
        skeletonStore.dispatch(SkeletonActionCreators.initialize());
    } catch (e) {
        yield put({
            type: AuthActionTypes.LOGIN_FAIL,
            message: e.message
        });
    }
}

export function* loginSuccessWatcher() {
    yield takeLatest(AuthActionTypes.LOGIN_SUCCESS, loginSuccess);
}

export function* loginFail(action: Action) {
    ToasterService.errorToast(
        responseCodePipe(action.error, loginSignupFailMessages)
    );
}

export function* loginFailWatcher() {
    yield takeLatest(AuthActionTypes.LOGIN_FAIL, loginFail);
}
